import {
  AllegroResponsiblePerson,
  AllegroResponsiblePersons,
} from './responsiblePersonTypes';

export const mockAllegroResponsiblePerson: AllegroResponsiblePerson = {
  id: '1f1cb463-1c3d-4c1f-a0c8-2c6f0d3a0f01',
  name: 'Osoba odpovědná za baterie',
  personalData: {
    name: 'Josef Novák',
    address: {
      countryCode: 'CZ',
      street: 'Václavské náměstí 1',
      postalCode: '11000',
      city: 'Praha',
    },
    contact: {
      email: 'josef.novak@example.cz',
      phoneNumber: '+420601123456',
    },
  },
};

export const mockGetAllegroResponsiblePersons: AllegroResponsiblePersons = {
  responsiblePersons: [mockAllegroResponsiblePerson],
  count: 1,
  totalCount: 1,
};
